export function accordion() {
  $( window ).on('load resize', function() {
    $('.accordion').each(function() {
      $(this).find('.btn-accordion').css('min-height', 0);

      var maxHeight = 0;
      $('.collapsed', this).each(function() {
        if($(this).outerHeight() > maxHeight) {
          maxHeight = $(this).outerHeight();
        }
      });
      $('.btn-accordion').each(function() {
        $(this).css('min-height', maxHeight);
      });
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/accordion.js